import { useState } from "react";

import { AlertV4, ButtonV4, FieldV4, ModalV4 } from "../common/ui";
import type { CheckoutInfo } from "./checkoutModelV4";

// Types
type ModalCancelCheckoutV4Props = {
  info: CheckoutInfo;
  saving?: boolean;
  error?: unknown;
  onConfirm: (note: string) => void;
  onClose: () => void;
};

const ModalCancelCheckoutV4 = (props: ModalCancelCheckoutV4Props) => {
  const [sent, setSent] = useState(false);
  const [note, setNote] = useState("");

  // Handler
  const handleConfirm = () => {
    if (!note.trim() || props.saving) return;
    setSent(true);
    props.onConfirm(note.trim());
  };

  // Render
  return (
    <ModalV4 title="ยกเลิก Check out" width={520} tone="danger" onClose={props.onClose}>
      <div className="hv4-co-body">
        <div className="hv4-co-undo-text">
          Check out แบบ <b>{props.info.typeText}</b>
          <br />
          <span>{props.info.atText}</span>
        </div>
        <div className="hv4-co-undo-warn">
          หลังยกเลิก สถานะจะกลับเป็น "กำลังพบแพทย์" และกด Check out ใหม่ได้
        </div>
        <FieldV4 label="เหตุผลที่ยกเลิก *" htmlFor="hv4_co_cancel_note">
          <textarea
            id="hv4_co_cancel_note"
            className="hv4-input"
            rows={3}
            required
            disabled={props.saving}
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </FieldV4>
        <AlertV4 tone="danger" error={sent ? props.error : null} />
        <div className="hv4-co-foot">
          <ButtonV4 variant="ghost" onClick={props.onClose}>
            ปิด
          </ButtonV4>
          <ButtonV4 variant="danger" disabled={!note.trim() || props.saving} onClick={handleConfirm}>
            ยืนยันยกเลิก Check out
          </ButtonV4>
        </div>
      </div>
    </ModalV4>
  );
};

ModalCancelCheckoutV4.displayName = "ModalCancelCheckoutV4";

export default ModalCancelCheckoutV4;
